module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagnematerialenA1BD39.f136c4fa.png";